// extracted by mini-css-extract-plugin
export var imgSliderWrapper = "slider-module--imgSliderWrapper--JO0yS";
export var sbShowMain = "slider-module--sb-show-main--AvOuR";